import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const DemandNoteForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    gpName: '',
    recipientName: '',
    residence: '',
    startYear: '',
    endYear: '',
    amountDue: '',
    feeAmount: '',
    noteDate: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="min-h-screen bg-[#f4f6f9] py-5 px-2 font-sans">
      <style>
        {`
          @media print {
            @page {
              size: A4;
              margin: 10mm;
            }
            body {
              visibility: hidden;
              background: white !important;
            }
            #printable-area {
              visibility: visible;
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              padding: 15mm;
              display: block !important;
              color: black !important;
            }
            .no-print {
              display: none !important;
            }
          }
        `}
      </style>

      {/* Main Form */}
      <div className="w-full bg-white border border-gray-300 shadow-sm rounded-sm overflow-x-auto no-print">
        <div className="bg-[#fff9e6] py-2 px-4 border-b border-gray-300 min-w-[1000px] flex justify-between items-center gap-2">
          <h2 className="text-[#b71c1c] text-left shrink text-[14px] sm:text-[17px] font-bold flex items-center  gap-2">
            <span className="text-blue-600 text-xl leading-none">✹</span> मागणीचा लेख (रिट नोटीस)
          </h2>
          <button onClick={() => navigate(-1)} className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-bold py-1 px-4 rounded text-sm no-print whitespace-nowrap shrink-0">
              मागे जा
            </button>
        </div>

        <div className="p-6 min-w-[1000px]">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-x-10 gap-y-6 mb-4">
            
            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">ग्रामपंचायतीचे नाव</label>
              <select name="gpName" value={formData.gpName} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm bg-white outline-none focus:border-blue-400">
                <option value="">ग्रामपंचायत निवडा</option>
                <option value="धामणी">धामणी</option>
              </select>
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">ज्या व्यक्तीस नोटीस द्यायचे त्याचे नाव</label>
              <input type="text" name="recipientName" placeholder="नाव प्रविष्ट करा" value={formData.recipientName} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm outline-none focus:border-blue-400" />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">राहणार</label>
              <input type="text" name="residence" placeholder="पत्ता" value={formData.residence} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm outline-none focus:border-blue-400" />
            </div>

            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">आर्थिक वर्ष 01 एप्रिल</label>
              <select name="startYear" value={formData.startYear} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm bg-white outline-none focus:border-blue-400">
                <option value="">वर्ष निवडा</option>
                <option value="2024">2024</option>
              </select>
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">ते 31 मार्च</label>
              <select name="endYear" value={formData.endYear} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm bg-white outline-none focus:border-blue-400">
                <option value="">वर्ष निवडा</option>
                <option value="2025">2025</option>
              </select>
            </div>
            <div></div>

            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">येणे असलेली रक्कम</label>
              <input type="text" name="amountDue" value={formData.amountDue} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm outline-none focus:border-blue-400" />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">मागणीच्या लेखाबद्दल फी रुपये</label>
              <input type="text" name="feeAmount" value={formData.feeAmount} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm outline-none focus:border-blue-400" />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">मागणीच्या लेखाचा दिनांक</label>
              <input type="date" name="noteDate" value={formData.noteDate} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm outline-none focus:border-blue-400" />
            </div>
          </div>

          <div className="mb-8">
            <p className="text-[11px] text-red-600 leading-relaxed font-medium">
              (टिप: मागणीच्या लेखाबद्दल फी- येणे असलेली रक्कम 25 रु. ते 100 रु. असल्यास 1 रु., जेव्हा 100 रु. पेक्षा जास्त रक्कम असेल तेव्हा पहिल्या 100 रु. साठी 1.5 रु. आणि 25 रुपयांच्या प्रत्येक अधिक रकमेबद्दल किंवा तिच्या भागाबद्दल 50 पैसे.)
            </p>
          </div>

          <div className="mt-10 flex gap-4 justify-center">
            <button onClick={handlePrint} className="bg-[#00a65a] text-white px-20 py-1.5 rounded-sm text-sm font-semibold shadow-sm hover:bg-[#008d4c]">Save</button>
            <button className="bg-[#f39c12] text-white px-10 py-1.5 rounded-sm text-sm font-semibold shadow-sm hover:bg-[#e08e0b]">Generate Document</button>
          </div>

          <div className="mt-8 border border-gray-300 rounded-sm min-h-[400px] bg-white"></div>

          <div className="mt-4">
            <button className="bg-[#f4f4f4] border border-[#ddd] text-[#444] px-5 py-1.5 rounded-sm text-xs flex items-center gap-2 hover:bg-[#e8e8e8]">
              <span>🖨️</span> Print
            </button>
          </div>
        </div>
      </div>

      {/* Printable Area */}
      <div id="printable-area" className="hidden print:block font-serif text-black bg-white">
        <div className="text-center mb-10 border-b border-black pb-4">
          <h1 className="text-[22px] font-bold">ग्रामपंचायत कार्यालय: {formData.gpName}</h1>
          <p className="text-[18px] font-bold mt-1">मागणीचा लेख (नोटीस)</p>
          <p className="text-[14px]">महाराष्ट्र ग्रामपंचायत कर व फी नियम, १९६० चा नियम १५ पहा</p>
        </div>

        <div className="flex justify-between mb-8">
          <div>जा.क्र./ग्रा.पं./नोटीस/२०२५-२६/</div>
          <div>दिनांक: {formData.noteDate}</div>
        </div>

        <div className="mb-8 leading-loose">
          <p>प्रति,</p>
          <p className="font-bold">{formData.recipientName}</p>
          <p>राहणार: {formData.residence}</p>
        </div>

        <p className="text-[16px] leading-relaxed mb-8 text-justify">
          येणेप्रमाणे कळविण्यात येते की, आपल्याकडे सन <b>{formData.startYear}</b> ते <b>{formData.endYear}</b> या वर्षाचे येणे असलेली कर/फी रक्कम रु. <b>{formData.amountDue}</b> व मागणी फी रु. <b>{formData.feeAmount}</b> अशी एकूण रक्कम रु. <b>{Number(formData.amountDue || 0) + Number(formData.feeAmount || 0)}</b> इतकी रक्कम थकबाकी आहे.
        </p>

        <p className="text-[16px] leading-relaxed mb-10 text-justify">
          सदर रक्कम आपण ही नोटीस मिळाल्यापासून १५ दिवसांच्या आत ग्रामपंचायत कार्यालयात जमा करावी. अन्यथा सदर रक्कम महाराष्ट्र ग्रामपंचायत अधिनियम १९५८ च्या कलम १२९ अन्वये सक्तीने वसूल करण्यात येईल याची नोंद घ्यावी.
        </p>

        <div className="flex justify-between items-end mt-20 pr-10 pl-10 font-bold text-center">
          <div></div>
          <div>
            <p>ग्रामसेवक /ग्रामविकास अधिकारी</p>
            <p>ग्रामपंचायत {formData.gpName}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DemandNoteForm;
